import React from 'react';
import TradeCategoryDetailSection from '../../../sections/AdminDashboard/TradeCategories/TradeCategoryDetail';

const TradeCategoryDetail = () => {
  return <TradeCategoryDetailSection />;
};

export default TradeCategoryDetail;
